"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetectionIcon = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var DetectionIcon = function DetectionIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.3333 2H2.83325C2.37524 2 2 2.37524 2 2.83325V12C2 12.4583 2.37524 12.8333 2.83325 12.8333H10.3333C10.7915 12.8333 11.1667 12.4583 11.1667 12V2.83325C11.1667 2.37524 10.7915 2 10.3333 2Z",
    fill: "#0095E0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.1667 11.1667H13.6667C13.2085 11.1667 12.8333 11.5417 12.8333 12V21.1667C12.8333 21.6248 13.2085 22 13.6667 22H21.1667C21.6248 22 22 21.6248 22 21.1667V12C22 11.5417 21.6248 11.1667 21.1667 11.1667Z",
    fill: "#0095E0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.3333 14.5H2.83325C2.37524 14.5 2 14.8752 2 15.3333V21.1667C2 21.6248 2.37524 22 2.83325 22H10.3333C10.7915 22 11.1667 21.6248 11.1667 21.1667V15.3333C11.1667 14.8752 10.7915 14.5 10.3333 14.5Z",
    fill: "#0095E0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.1667 2H13.6667C13.2085 2 12.8333 2.37524 12.8333 2.83325V8.66675C12.8333 9.12476 13.2085 9.5 13.6667 9.5H21.1667C21.6248 9.5 22 9.12476 22 8.66675V2.83325C22 2.37524 21.6248 2 21.1667 2Z",
    fill: "#0095E0"
  }));
};
exports.DetectionIcon = DetectionIcon;